import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateDeviceSignalDocument } from './update.generated';

export const useUpdateDeviceSignal = (
  options: ApiOptions<typeof UpdateDeviceSignalDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(UpdateDeviceSignalDocument, {
    ...useNotifications(UpdateDeviceSignalDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.device_signals.update_success'),
    }),
    ...options,
  });
};
